export function normalizeLegacyRoute(value) {
    if (!value) {
        return '';
    }
    return value
        .trim()
        .replace(/^#\/?/, '')
        .replace(/^\/+/, '')
        .replace(/\/+$/, '');
}
export function getHomeRedirectTarget(pathname, hash, search) {
    const hashRoute = normalizeLegacyRoute(hash);
    const pathnameRoute = normalizeLegacyRoute(pathname.replace(/^\/home(?:\/|$)/, ''));
    const route = hashRoute || pathnameRoute;
    const target = route ? `/public/redirect/${encodeURI(route)}` : '/public/redirect';
    return `${target}${search || ''}`;
}
